<template>
    <v-iframe-sandbox :html="html" highlight="pre > code"></v-iframe-sandbox>
</template>

<script>
    import isJSONString from '@/common/helpers/is-json-string';
    import isXMLString from '@/common/helpers/is-xml-string';
    import prepareViewHTML from '@/components/pretty-data-render/prepare-view-html';
    import vIframeSandbox from '@/components/v-iframe-sandbox';
    import DefaultView from './views/default-view';
    import JsonView from './views/json-view';
    import XmlView from './views/xml-view';

    const formatters = {
        json: {
            validator: isJSONString,
            formatter: JsonView,
        },
        xml: {
            validator: isXMLString,
            formatter: XmlView,
        },
        default: {
            validator: () => true,
            formatter: DefaultView,
        },
    };

    export default {
        name: 'pretty-data-render',
        components: {
            vIframeSandbox,
        },
        props: {
            // future feature short preview
            flatten: {
                type: Boolean,
                default: false,
            },
            value: {
                type: String,
                default: null,
            },
        },
        computed: {
            html() {
                const {value, flatten} = this.$props;

                try {
                    const [format, {formatter}] = Object
                        .entries(formatters)
                        .find(([, {validator}]) => validator(value));
                    return prepareViewHTML(formatter({value, flatten}), format);
                } catch (e) {
                    return prepareViewHTML(formatters.default.formatter({value, flatten}));
                }
            },
        },
    };
</script>
